import { ReputationFeatureSubTypeEnum } from '@reach/shared-types/automation-template';
import type {
  AutomationFeatureSubType,
  ReputationFeatureSubType,
} from '@reach/shared-types/automation-template';
import styles from './templates-table.module.css';

const LABEL_BY_SUB_TYPE: Partial<Record<ReputationFeatureSubType, string>> = {
  [ReputationFeatureSubTypeEnum.INTERNAL_REVIEW]: 'Private feedback',
  [ReputationFeatureSubTypeEnum.GOOGLE_REVIEW]: 'Google review',
  [ReputationFeatureSubTypeEnum.POST_INTERNAL_REVIEW]: 'Google review after feedback',
  [ReputationFeatureSubTypeEnum.BOTH_REVIEWS]: 'Both',
};

interface ReviewFlowRoleCellProps {
  featureSubType: AutomationFeatureSubType | undefined;
}

/**
 * Which role a reputation template plays in the tenant's selected review flow. A copy of a
 * default keeps its sub-type, so two rows sharing a label on the same tenants both fire.
 */
export function ReviewFlowRoleCell({ featureSubType }: ReviewFlowRoleCellProps) {
  const label = featureSubType ? LABEL_BY_SUB_TYPE[featureSubType] : undefined;

  if (!label) {
    return (
      <td>
        <span className={styles.reviewFlowRoleEmpty}>—</span>
      </td>
    );
  }

  return (
    <td>
      <span className={styles.reviewFlowRole}>{label}</span>
    </td>
  );
}
